<template>
<div class="clum2right right">
  <div id="content_block" class="right">
    <div class="account_icon right"> </div>
    <div class="content_title right">پروفایل من > تغییر رمز عبور</div>
    <div id="content_main" class="right">
      <div class="pure-form pure-form-aligned">
        <fieldset>
          <div class="pure-control-group" style="line-height: 50px;">
            <label  for="newpsw">ریست رمز عبور</label>
            <input class="pure-input-2-3" id="newpsw" type="password" placeholder="رمز عبور" v-model="newpsw">
          </div>

          <div class="pure-control-group" style="line-height: 50px;">
            <label for="confirmPsw">تایید رمز عبور</label>
            <input class="pure-input-2-3" id="confirmPsw" type="password" placeholder="تایید رمز عبور" v-model="confirmpsw">
          </div>

          <div class="pure-controls" style="float: left;">
            <button type="reset" value="Reset" class="button-warning pure-button pure-button-primary" style="width: 160px;" @click="cancel()">لغو</button>
            <button type="submit" class="button-warning pure-button pure-button-primary" style="width: 160px;" @click="clicksave()">ذخیره سازی</button>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</div>
</template>
<script>
/*jshint esversion: 6 */
import {getDataUrl} from '../../../tools/getUrl.js';
import router from '../../../router.js';
export default {
  data: function() {
    return {
      modelIsOpen: false,
      newpsw: '',
      confirmpsw: ''
    };
  },
  methods: {
    cancel: function() {
      router.replace('/Main/Profile');
    },
    clicksave: function() {
      var strRightpsw;
      if (this.newpsw === this.confirmpsw) {
        strRightpsw = this.newpsw;
        var obj = {
            api: 'modify_account',
            account_id: sessionStorage.getItem('accountid'),
            passwd: strRightpsw,
            output: 'json'
          },
          url = getDataUrl(obj);
        // btnProfile = this.$els.btnProfile;
        this.$http.get(url).then((response) => {
          // success callback
          if (response.data > 0) {
            sessionStorage.setItem('psw', this.newpsw);
            alert('رمز عبور شما  تغییر داده شد.');
            router.replace('/Main/Profile');
          } else {
            alert('رمز عبور شما  تغییر داده نشد است، لطفا دوباره تلاش کنید.');
          }
        }, (response) => {
          // error callback
        });
      } else {
        alert('رمز عبور ها مطابقت ندارد.');
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// Changepsw.vue?37492c02